import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M21.33 8a5.333 5.333 0 1 1-10.666 0 5.333 5.333 0 0 1 10.667 0"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M19.306 29.228c-.968.07-2.064.106-3.303.106-10.667 0-10.667-2.686-10.667-6s4.776-6 10.667-6c3.84 0 7.207 1.142 9.085 2.855-.688-.188-1.654-.188-3.085-.188-2.2 0-3.3 0-3.984.683-.683.683-.683 1.783-.683 3.983s0 3.3.683 3.984c.317.316.723.486 1.287.577",
      opacity: ".5"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M22.003 29.333c-2.2 0-3.3 0-3.984-.683-.683-.683-.683-1.783-.683-3.983s0-3.3.683-3.984C18.703 20 19.803 20 22.003 20s3.3 0 3.983.683c.683.684.683 1.784.683 3.984s0 3.3-.683 3.983c-.684.683-1.783.683-3.983.683m.777-6.74a.778.778 0 1 0-1.555 0v1.296h-1.297a.778.778 0 0 0 0 1.555h1.297v1.297a.778.778 0 1 0 1.555 0v-1.297h1.297a.778.778 0 0 0 0-1.555H22.78z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }